import { LanguageType } from "@/enums/enums";
import {
  DocumentIdModel,
  DocumentTemplateHeaderTypeModel,
  DocumentUpdateOnlineViewPassCodeModel,
  DocumentWithPassCodeModel,
} from "@/model/document/documentModel";
import {
  SettingContactEnvelopeDocumentTemplateModel,
  SettingDocumentTemplateModel,
  SettingExecutiveSummaryDocumentTemplateModel,
  SettingJournalDocumentTemplateModel,
  SettingPP30DocumentTemplateModel,
  SettingPndDocumentTemplateModel,
  SettingWitholdingTaxDocumentTemplateModel,
} from "@/model/document/settingDocumentTemplate";

export function PrepareDocumentInputData(input: DocumentTemplateHeaderTypeModel) {
  const data = {
    transactionId: input.transactionId,
    option: {
      documentVersion: 0,
      templateVersion: 0,
      headerOptionType: input.headerType,
      language: 1,
    },
  };
  return data;
}

export function PrepareDocumentPublicLinkInputData(input: DocumentWithPassCodeModel) {
  const data = {
    transactionId: input.transactionId,
    passCode: input.passCode,
    option: {
      documentVersion: 0,
      templateVersion: 0,
      headerOptionType: input.headerType,
      language: 1,
    },
  };
  return data;
}

export function PrepareUpdateDetailDocumentInputData(input: any) {
  const data = {
    transactionId: input.transactionId,
    updateVersion: input.updateVersion,
    language: LanguageType.Th,
  };
  return data;
}

export function PrepareOnlineViewPassCodeDocumentInputData(input: DocumentUpdateOnlineViewPassCodeModel) {
  const data = {
    transactionId: input.transactionId,
    transactionType: input.transactionType,
    financeType: input.financeType,
    sourceType: input.sourceType,
  };
  return data;
}

export function PrepareOnlineViewTemplateDocumentInputData(
  settingDocumentTemplate:
    | SettingDocumentTemplateModel
    | SettingJournalDocumentTemplateModel
    | SettingWitholdingTaxDocumentTemplateModel
    | SettingPP30DocumentTemplateModel
    | SettingPndDocumentTemplateModel
    | SettingContactEnvelopeDocumentTemplateModel
    | SettingExecutiveSummaryDocumentTemplateModel,
  documentId: DocumentIdModel,
  headerOptionType: Number
) {
  const data = {
    transactionId: documentId.transactionId,
    documentType: documentId.transactionType,
    financeType: documentId.financeType,
    headerOptionType: headerOptionType,
    template: settingDocumentTemplate,
    sourceType: documentId.sourceType,
  };
  return data;
}

export function PrepareOnlineViewTemplateMainDocumentInputData(
  settingDocumentTemplate:
    | SettingDocumentTemplateModel
    | SettingJournalDocumentTemplateModel
    | SettingWitholdingTaxDocumentTemplateModel
    | SettingPP30DocumentTemplateModel
    | SettingPndDocumentTemplateModel
    | SettingContactEnvelopeDocumentTemplateModel
    | SettingExecutiveSummaryDocumentTemplateModel,
  documentId: DocumentIdModel,
  headerOptionType: Number
) {
  const data = {
    documentType: documentId.transactionType,
    financeType: documentId.financeType,
    headerOptionType: headerOptionType,
    template: settingDocumentTemplate,
    sourceType: documentId.sourceType,
  };
  return data;
}
